export const sectionHeads = [
  { title: "Apps We Love", sectionKey: "appsWeLove" },
  { title: "People Are Loving", sectionKey: "peopleAreLoving" },
  { title: "Dashboard", sectionKey: "dashboard" }
];
